import isEmpty from 'lodash/isEmpty'
import { DEFAULT_LANG } from 'config/languages'

export function parseLocalDate(date, lang) {
   if (!date || !lang) {
      return ''
   }
   const test = new Date(`${date} 00:00:00`)
   return new Intl.DateTimeFormat(lang, {
      dateStyle: 'long',
   }).format(test)
}

export function formatDate(date) {
   if (!date) {
      return null
   }
   const dateObject = new Date(`${date} 00:00:00`)
   const dateParts = new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
   }).formatToParts(dateObject)

   const month = dateParts.find((el) => el.type === 'month')?.value
   const day = dateParts.find((el) => el.type === 'day')?.value
   const year = dateParts.find((el) => el.type === 'year')?.value

   return [year, month, day].join('/')
}

export function getCatUrl(categoryName, path) {
   switch (categoryName) {
      case 'podcast':
         return `${path}podcasts/`
      case 'video':
         return `${path}videos/`
      default:
         return `${path}${categoryName}/`
   }
}

export function handleTwitterData(author) {
   if (isEmpty(author.socials)) return null

   const hasTwitter = !isEmpty(author.socials.filter((social) => social.name === 'twitter'))

   if (!hasTwitter) return null

   let twitterUrl = author.socials.filter((social) => social.name === 'twitter')[0].url

   if (twitterUrl) {
      if (twitterUrl[twitterUrl.length - 1] === '/') {
         twitterUrl = twitterUrl.slice(0, -1)
      }

      const stringAfterLastSlash = twitterUrl.slice(twitterUrl.lastIndexOf('/') + 1)

      let twitterName = ''

      if (stringAfterLastSlash[stringAfterLastSlash.length] === '/') {
         twitterName = stringAfterLastSlash.slice(0, stringAfterLastSlash.length - 1).toLowerCase()
      } else {
         twitterName = stringAfterLastSlash.toLowerCase()
      }

      return { twitterUrl, twitterName }
   }
}

export function testEmail(email) {
   if (email) {
      return /^[\w-.]+@([\w-]+\.)+[\w-]{2,9}$/.test(email)
   }
}

export function insert(arr, index, newItem) {
   return [...arr.slice(0, index), newItem, ...arr.slice(index)]
}

export function updateListSlugs(list = [], langPrefix) {
   return list.map(({ node }) => {
      const parsedDate = node.postDate && formatDate(node.postDate)
      const url = `${langPrefix}${parsedDate}${node.slug}`
      return { ...node, slug: url }
   })
}

export function validateEmail(email) {
   return String(email)
      .toLowerCase()
      .match(
         /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
}

export function capitalizeFirstLetter(string) {
   return string.charAt(0).toUpperCase() + string.slice(1)
}

export function encode(data) {
   return Object.keys(data)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&')
}

export function downloadBlob(blob, filename) {
   // Create an object URL for the blob object
   const url = URL.createObjectURL(blob)

   // Create a new anchor element
   const a = document.createElement('a')

   // Set the href and download attributes for the anchor element
   // You can optionally set other attributes like `title`, etc
   // Especially, if the anchor element will be attached to the DOM
   a.href = url
   a.download = filename || 'download'

   // Click handler that releases the object URL after the element has been clicked
   // This is required for one-off downloads of the blob content
   const clickHandler = () => {
      setTimeout(() => {
         URL.revokeObjectURL(url)
         a.removeEventListener('click', clickHandler)
      }, 150)
   }

   // Add the click event listener on the anchor element
   // Comment out this line if you don't want a one-off download of the blob content
   a.addEventListener('click', clickHandler, false)

   // Programmatically trigger a click on the anchor element
   // Useful if you want the download to happen automatically
   // Without attaching the anchor element to the DOM
   // Comment out this line if you don't want an automatic download of the blob content
   a.click()

   // Return the anchor element
   // Useful if you want a reference to the element
   // in order to attach it to the DOM or use it in some other way
   return a
}

export function generatePostSlug(post) {
   const parsedDate = post.postDate && formatDate(post.postDate)
   const langPrefix = post.node_locale === DEFAULT_LANG ? '/' : `/${post.node_locale}/`
   const url = `${langPrefix}${parsedDate}${post.slug}`
   return url
}
